class HeaderTransparentEnhancement {
  constructor() {
    this.header = document.querySelector('.header-wrapper');
    this.scrollThreshold = 20; // Ativar o blur mais cedo
    this.isScrolled = false;
    
    if (this.header) {
      this.init();
    }
  }

  init() {
    // Adicionar classe inicial
    this.header.classList.add('header-transparent');
    
    // Listener para scroll
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    
    // Listener para resize para ajustar em mudanças de orientação
    window.addEventListener('resize', this.handleResize.bind(this));
    
    // Configuração inicial
    this.handleScroll();
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const shouldBeScrolled = scrollTop > this.scrollThreshold;
    
    if (shouldBeScrolled !== this.isScrolled) {
      this.isScrolled = shouldBeScrolled;
      
      if (this.isScrolled) {
        this.header.classList.add('header-transparent--scrolled');
      } else {
        this.header.classList.remove('header-transparent--scrolled');
      }
    }
  }

  handleResize() {
    // Reagir a mudanças de orientação e viewport
    this.handleScroll();
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeaderTransparentEnhancement();
  });
} else {
  new HeaderTransparentEnhancement();
} 